import { AccessSelector } from "../../../components/accessSelector";
import { PinPad } from "../../../components/pinPad";
import React, { useState, useEffect } from "react";
//Redux
import { useDispatch, useSelector } from "react-redux";

import { LuUser } from "react-icons/lu";
import { checkPassword, getUsersAccess, logIn } from "../../../api/login";
import "./style.css";
import { setAlert, setComponentActive, setUserLogged } from "../../../reducers/userConfigSlice";
import { saveLoginLS } from "@delibrandev/utils";
import { logout } from "../../../api/requests";
import { apiRest } from "../../../api/constants";

export const UserSelect = () => {
  const dispatch = useDispatch();
  const [menu, setMenu] = useState("");
  const [userData, setUserData] = useState({});
  const [users, setUsers] = useState([]);
  const [loginData, updateLoginData] = useState({});
  const Logo = useSelector((state) => state.aplicationConfig.corporationData.info.logo);

  useEffect(() => {
    logout();
  }, []);

  const getUsers = async () => {
    const response = await getUsersAccess();
    if (!response || response.error || !Array.isArray(response.data)) {
      throw new Error("users-unavailable");
    }
    setUsers(response.data);
  };

  const handleUser = async (pinValue) => {
    const payload = {
      userId: userData.userId,
      pin: pinValue,
    };
    const response = await logIn(payload);
    if (response && !response?.error && !response?.data?.error) {
      saveLoginLS({ ...loginData, login: payload }, apiRest);
      dispatch(setUserLogged(true));
      dispatch(setComponentActive("orders"));
    } else {
      dispatch(setAlert({ called: true, title: "Error", message: (response?.data?.message || response?.message) === "PIN is not active." ? "El PIN está desactivado. Solicita acceso al administrador." : /access|permited/i.test(response?.data?.message || response?.message || "") ? "No tienes permiso para esta plataforma o puesto." : "Contraseña incorrecta", type: "error" }));
    }
  };

  const handlePassword = (pinValue) => {
    return handleMenu("password", pinValue, "users");
  };

  const handleMenu = async (key, data, nextMenu) => {
    //Check password
    if (key === "password") {
      const password = data;
      const payload = {
        password: password,
      };
      const response = await checkPassword(payload);
      if (response && !response.error) {
        updateLoginData({ ...loginData, password: password });
        try {
          await getUsers();
          setMenu(nextMenu);
        } catch {
          dispatch(setAlert({ called: true, title: "Usuarios no disponibles", message: "No se pudieron cargar los usuarios. Vuelve a intentarlo.", type: "error" }));
        }
      } else {
        dispatch(setAlert({ called: true, title: "Error", message: "Contraseña incorrecta", type: "error" }));
      }
    }

    //Select User
    if (key === "select-user-manager") {
      setUserData(data);
      setMenu(nextMenu);
    }
  };

  const HandlerMenu = () => {
    let component = <></>;
    if (menu === "users") {
      component = (
        <>
          <AccessSelector
            head={"SELECTOR DE USUARIO"}
            emptyMessage="No hay usuarios con acceso al reparto. Revisa la configuración en Admin."
            data={users}
            icon={<LuUser />}
            callback={(e) => handleMenu("select-user-manager", e, "pin")}
            title={"Seleccione un usuario"}
          />
        </>
      );
    } else if (menu === "pin") {
      component = <PinPad callback={handleUser} inputText="Ingrese su pin" head={"ACCESO USUARIO"} />;
    } else {
      component = <PinPad allowText callback={handlePassword} inputText="Ingrese la contraseña" head={"ACCESO PLATAFORMA"} />;
    }
    return component;
  };

  return (
    <div className="loginArea">
      <div className="verticalLoginFlex">
        <div className="logoContainer">
          <img src={Logo} alt="logo" className="logoLogin" />
        </div>
        {HandlerMenu()}
      </div>
    </div>
  );
};
